import { post } from '@core/api/baseApi';
import { CustomErroHandlerResponse, PostUserSettingsResponse } from '@core/types';

const setUserPreferences = (
  payload: string,
): Promise<PostUserSettingsResponse | CustomErroHandlerResponse> =>
  post(`/users/settings`, { settings: payload });

export default setUserPreferences;
